export const NEW_GOODS_RECEIPT_ID = 'NEW_GOODS_RECEIPT_ID'
export const PRODUCT_OVERSCANNED = 'PRODUCT_OVERSCANNED'
export const SCANNED_CODE_NOT_IN_GOODS_RECEIPT =
  'SCANNED_CODE_NOT_IN_GOODS_RECEIPT'
export const SCANNED_CODE_IN_GOODS_RECEIPT = 'SCANNED_CODE_IN_GOODS_RECEIPT'
